import { Swiper } from 'swiper';
import { A11y, Navigation, Scrollbar } from 'swiper/modules';

const propelInit = function() {
const newTeamCardBlocks = document.querySelectorAll('.block-new-team-card');

newTeamCardBlocks?.forEach((block) => {
	const swiperContainer = block.querySelector(
		'.block-new-team-card__slider.swiper'
	);

	const parentBlock = swiperContainer.closest('.acf-block');
	const scrollbar = parentBlock?.querySelector('.swiper-scrollbar');
	const mobileGap = parentBlock?.dataset?.mobileSliderGap ?? 8;
	const desktopGap = parentBlock?.dataset?.desktopSliderGap ?? 8;

	const settings = {
		slidesPerView: 'auto',
		spaceBetween: mobileGap,
		grabCursor: true,
		loop: false,
		modules: [A11y, Navigation],
		a11y: {
			itemRoleDescriptionMessage: 'slide',
		},
		navigation: {
			nextEl: block.querySelector('.swiper-button-next'),
			prevEl: block.querySelector('.swiper-button-prev'),
		},
		breakpoints: {
			768: {
				spaceBetween: desktopGap,
			},
		},
	};

	if (scrollbar) {
		settings.modules.push(Scrollbar);

		settings.scrollbar = {
			el: scrollbar,
			draggable: true,
		};
	}

	// Deferred two to avoid forced reflow. Make sure CSS makes the block appear the same before and after swiper initializes, to avoid CLS.
	requestAnimationFrame(() => {
		requestAnimationFrame(() => {
			new Swiper(swiperContainer, settings);
		});
	});
});

};
propelInit();
window.propel = window.propel || {};
window.propel.blocks = window.propel.blocks || {};
window.propel.blocks['new-team-card'] = window.propel.blocks['new-team-card'] || {};
window.propel.blocks['new-team-card'].script = propelInit;
